import React, { useEffect, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap'
import reactStringReplace from 'react-string-replace'
import AddTask from './AddTask';
import CreateTaskModel from './models/TaskModel';
import ViewTask from './ViewTask';
import EditTask from './EditTask';
import DeleteTask from './DeleteTask';
import * as Icons from "react-feather";

function TaskModal({ onClose, onSubmit, UserAction, show, selectedRow }) {
    const [childData, setChildData] = useState(new CreateTaskModel() || []);
    let modalAction;
    let showButtons;
    let userAction = reactStringReplace(UserAction, 'User', () => '');

    useEffect(() => {
        setChildData(selectedRow);
    }, [selectedRow]);

    const handleDataFromChild = (data) => {
        setChildData(data);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(e, childData);  // Send the form data back to the parent component
    };

    if (UserAction === "Add") {
        modalAction = <AddTask onSubmit={onSubmit} sendDataToParent={handleDataFromChild} />
        showButtons = <div>
            <button className="btn btn-cancel me-2" name="Add" onClick={onClose}>Cancel</button>
            <button className="btn btn-submit" name="Add" onClick={handleSubmit}> Submit </button>
        </div>
    }
    else if (UserAction === "Edit") {
        modalAction = <EditTask TaskData={selectedRow} onSubmit={onSubmit} sendDataToParent={handleDataFromChild} />
        showButtons = <div>
            <button className="btn btn-cancel me-2" name="Edit" onClick={onClose}>Cancel</button>
            <button className="btn btn-submit" name="Edit" onClick={handleSubmit}> Submit </button>
        </div>
    } else if (UserAction === "View") {
        modalAction = <ViewTask TaskData={selectedRow} />
        showButtons = <div>
            <button className="btn btn-cancel me-2" name="View" onClick={onClose}>Cancel</button>
        </div>
    } else if (UserAction === "Delete") {
        modalAction = <DeleteTask TaskData={selectedRow} />
        showButtons = <div>
            <button className="btn btn-sm btn-secondary m-1" name="Delete" onClick={onClose}>Cancel</button>
            <button className="btn btn-sm btn-danger m-1" name="Delete" onClick={handleSubmit}>Delete</button>
        </div>
    }
    return (
        UserAction !== "Delete" ?
            <Modal
                show={show}
                onHide={onClose}
                backdrop="static"
                dialogClassName="modal-dialog modal-dialog-centered stock-adjust-modal task-modal"
            >
                <ModalHeader className="modal-header border-0 custom-modal-header" closeButton>
                    <ModalTitle >{userAction}  New Task</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    {modalAction}
                </ModalBody>
                <ModalFooter className="">
                    {showButtons}
                </ModalFooter>
            </Modal>
            : <Modal
                show={show}
                onHide={onClose}
                backdrop="static"            >

                <ModalHeader className="alert custom-alert1 alert-danger modalheader-width">
                    <ModalTitle>
                        <div className="custom-alert-icon">
                            <Icons.AlertOctagon className="flex-shrink-0" />
                        </div>
                        <div > {userAction} Task</div>
                    </ModalTitle>
                </ModalHeader>

                <ModalBody>
                    {modalAction}
                </ModalBody>
                <ModalFooter className="modalfooter-width">
                    {showButtons}
                </ModalFooter>
            </Modal>

    )
}

export default TaskModal